import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import Login from './pages/Login';
import CourseList from './pages/CourseList';
import CourseDetail from './pages/CourseDetail';
import Profile from './pages/Profile';
import CourseForm from './pages/CourseForm';
import LessonForm from './pages/LessonForm';
import Register from './pages/Register';
import LessonView from './pages/LessonView';
import QuizView from './pages/QuizView';
import QuizEditor from './pages/QuizEditor';
import logo from './images/logo.png';
import Dashboard from './pages/Dashboard';

function App() {
    const isAuthenticated = !!localStorage.getItem('access_token');

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        
    };

    return (
        <BrowserRouter>
            {isAuthenticated && (
                <Navbar bg="white" variant="light" expand="lg" className="shadow-sm py-2">
                    <Container>
                        <Navbar.Brand as={Link} to="/courses" className="text-primary fw-bold">
                            <img 
                                src={logo} 
                                alt="LMS Logo" 
                                style={{ 
                                    height: '60px', 
                                    width: '160px',
                                    marginRight: '12px',
                                    backgroundColor: '#ffffff',  // 👈 BIAŁE TŁO
                                }} 
                            />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ms-auto">
                                <Nav.Link as={Link} to="/dashboard" className="text-dark fw-medium">Strona główna</Nav.Link>
                                <Nav.Link as={Link} to="/courses" className="text-dark fw-medium">
                                    Kursy
                                </Nav.Link>
                                <Nav.Link as={Link} to="/profile" className="text-dark fw-medium">
                                    Profil
                                </Nav.Link>
                                <Nav.Link onClick={handleLogout} className="text-danger fw-medium">
                                    Wyloguj
                                </Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            )}

            <Routes>
                <Route 
                    path="/" 
                    element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />} 
                />
                <Route path="/login" element={<Login />} 
                />
                <Route path="/register" element={<Register />} />
                <Route path="/courses" element={isAuthenticated ? <CourseList /> : <Navigate to="/login" />} 
                />
                {/* lesson create przed id courses create bo szuka złej metody */}
                <Route 
                    path="/courses/:courseId/sections/:sectionId/lessons/create" 
                    element={isAuthenticated ? <LessonForm /> : <Navigate to="/login" />} 
                />
                <Route 
                    path="/courses/:courseId/sections/:sectionId/lessons/:lessonId/edit" 
                    element={isAuthenticated ? <LessonForm /> : <Navigate to="/login" />} 
                />
                <Route 
                    path="/courses/:courseId/lessons/:lessonId/quiz" 
                    element={isAuthenticated ? <QuizView /> : <Navigate to="/login" />} 
                />
                <Route 
                    path="/courses/:courseId/lessons/:lessonId/quiz/edit" 
                    element={isAuthenticated ? <QuizEditor /> : <Navigate to="/login" />} 
                />
                <Route path="/courses/:id" element={isAuthenticated ? <CourseDetail /> : <Navigate to="/login" />} 
                />
                <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/login" />} 
                />
                <Route path="/" element={<Navigate to="/courses" />} />
                <Route path="/courses/create" element={isAuthenticated ? <CourseForm /> : <Navigate to="/login" />} 
                />
                <Route path="/courses/:id/edit" element={isAuthenticated ? <CourseForm /> : <Navigate to="/login" />} 
                />
                <Route 
                    path="/courses/:courseId/lessons/:lessonId" 
                    element={isAuthenticated ? <LessonView /> : <Navigate to="/login" />} 
                />
                <Route 
                    path="/dashboard" 
                    element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} 
                />

            </Routes>
        </BrowserRouter>
    );
}

export default App;